export function split<T extends object, K extends keyof T>(obj: T, key: K): { extracted: T[K]; rest: Omit<T, K> };

export function split<T extends object, K extends keyof T>(
    obj: undefined | null,
    key: K,
): { extracted: undefined; rest: undefined };

export function split<T extends object, K extends keyof T>(
    obj: T | undefined | null,
    key: K,
): { extracted: T[K] | undefined; rest: Omit<T, K> | undefined };

// Function implementation
export function split(obj: any, key: PropertyKey) {
    if (obj == null || typeof obj !== 'object') {
        return { extracted: undefined, rest: undefined } as const;
    }
    const { [key]: extracted, ...rest } = obj as Record<PropertyKey, unknown>;
    return { extracted, rest } as const;
}
